module.exports = __webpack_public_path__ + "static/media/headerLogo.3dc37ae9.png";